/**
 * Introduction
 * The RevSpring REST API provides a powerful and easy way to integrate RevSpring functionality into your own applications.You can browse through the supported operations in the Resources and Operations section below. You can even invoke the operations directly from this page using the corresponding \"Try this\" operation functionality!  Before using the RevSpring API, you will need to contact your RevSpring Account Representative. If you are new to RevSpring, please complete the following form to get the contract process started: [Contact Us Form](http://revspringinc.com/contact-us/) ## Getting started:   1. Obtain a unique set of credentials (a client_id, a client_secret) for use in your application by contacting  your RevSpring Account Manager. The client_id and the client_secret are required in order to generate an Access  Token. The RevSpring Account Manager will also be providing the clientId and clientType as these values are  required in all API calls other than the Auth operations.    2. All of the API calls require an Auth Access Token. Use the credentials provided in step 1 to generate an Auth  Access Token using the following method: /api/rest/auth/oauth/token.     3. Use the access_token returned to call any of the available REST API Operations. When calling other operations,  you will need to use the clientId and clientIdType in the Header along with the access_token.    4. The Try this operation button is available within each operation for testing.    ## Using the \"Try this\" operation functionality:  To use the \"Try this\" operation functionality applicable to each operation,  first provide valid values for each parameter under the \"Parameter\" column. To easily populate complex parameter values, select Model Schema under the \"Data Type\" column and then click on the JSON text that is revealed. You can then edit the populated \"Value\" field as needed, and click the corresponding \"Try this\" operation button to watch the API operation in action.    ## Try Postman :  Open the links and save to download the files. <a href = \"/apidoc/v1/api/postman/EM3_collection.json\"><strong>Postman Collection</strong></a>  <a href = \"/apidoc/v1/api/postman/EM3_environment.json\"><strong>Postman Variables</strong></a>  <br>   ## Error Codes :  Error codes which may appear when working with the API.  <a href = \"/apidoc/v1/api/errorcodes/codes.html\"><strong>Error Codes</strong></a>  <br> <br> © 2019 RevSpring. All Rights Reserved.  [Terms](http://revspringinc.com/terms-conditions/)   [Privacy](http://revspringinc.com/privacy-policy/) ## Resources and Operations
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AccessTokenError } from '../model/accessTokenError';
import { AdminInfo6 } from '../model/adminInfo6';
import { AdminMaskPciDataRequestInfo } from '../model/adminMaskPciDataRequestInfo';
import { AlertRetrieveResponseInfo } from '../model/alertRetrieveResponseInfo';
import { AlertUpdateRequestInfo } from '../model/alertUpdateRequestInfo';
import { AlertUpdateResponseInfo } from '../model/alertUpdateResponseInfo';
import { ErrorMessage } from '../model/errorMessage';
import { EventLogRequestInfo } from '../model/eventLogRequestInfo';
import { EventLogRetrieveResponseInfo } from '../model/eventLogRetrieveResponseInfo';
import { EventRequestInfo } from '../model/eventRequestInfo';
import { EventResponseInfo } from '../model/eventResponseInfo';
import { EventResponseInfo2 } from '../model/eventResponseInfo2';
import { EventRetrieveAllResponse } from '../model/eventRetrieveAllResponse';
import { EventUpdateRequestInfo } from '../model/eventUpdateRequestInfo';
import { NotificationLogRetrieveResponseInfo } from '../model/notificationLogRetrieveResponseInfo';
import { NotificationTemplateRequestInfo } from '../model/notificationTemplateRequestInfo';
import { NotificationTemplateResponseInfo } from '../model/notificationTemplateResponseInfo';
import { NotificationTemplateResponseInfo2 } from '../model/notificationTemplateResponseInfo2';
import { NotificationTemplateUpdateRequestInfo } from '../model/notificationTemplateUpdateRequestInfo';
import { PolicyCreateRequestInfo } from '../model/policyCreateRequestInfo';
import { PolicyCreateResponseInfo } from '../model/policyCreateResponseInfo';
import { PolicyDefinitionCreateRequestInfo } from '../model/policyDefinitionCreateRequestInfo';
import { PolicyDefinitionCreateResponseInfo } from '../model/policyDefinitionCreateResponseInfo';
import { PolicyDefinitionRetreiveResponse } from '../model/policyDefinitionRetreiveResponse';
import { PolicyDefinitionUpdateRequestInfo } from '../model/policyDefinitionUpdateRequestInfo';
import { PolicyRetreiveResponse } from '../model/policyRetreiveResponse';
import { PolicyUpdateRequestInfo } from '../model/policyUpdateRequestInfo';
import { ReteieveResponse } from '../model/reteieveResponse';
import { ReteieveResponse2 } from '../model/reteieveResponse2';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class EvtMgrService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (let consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * EvtMgr_AdminInfo, Get the Admin Info
     * Gives the latest Version Control and Host Info
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1AdminInfoGet(observe?: 'body', reportProgress?: boolean): Observable<AdminInfo6>;
    public evtMgrV1AdminInfoGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminInfo6>>;
    public evtMgrV1AdminInfoGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminInfo6>>;
    public evtMgrV1AdminInfoGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<AdminInfo6>(`${this.basePath}/EvtMgr/V1/Admin/Info`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_MaskPciData, set or unset the flag for masking
     * This API would help to mask or unmask PCI data on the fly for more debugging or analysis
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1AdminMaskPciDataPost(Request: AdminMaskPciDataRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public evtMgrV1AdminMaskPciDataPost(Request: AdminMaskPciDataRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public evtMgrV1AdminMaskPciDataPost(Request: AdminMaskPciDataRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public evtMgrV1AdminMaskPciDataPost(Request: AdminMaskPciDataRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1AdminMaskPciDataPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/EvtMgr/V1/Admin/MaskPciData`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrieveAlert, Retrieve an Alert
     * Retrieve an Alert
     * @param Type Enter the Type
     * @param Category Enter the Category
     * @param SubCategory Enter the SubCategory
     * @param Component Enter the Component
     * @param IpAddress Enter the IpAddress
     * @param OrgId Enter the OrgId
     * @param Level Enter the Level
     * @param State Enter the State
     * @param StartDateTime Enter the LastOccurance StartDateTime in yyyy-MM-dd&#39;T&#39;HH:mm:ss format
     * @param EndDateTime Enter the LastOccurance EndDateTime in yyyy-MM-dd&#39;T&#39;HH:mm:ss format, Range between Start and EndateTime be less than 7 days
     * @param PageNumber Enter the page number, where page number starts from 1.
     * @param PageSize Enter the records per page. Default page size is 5000.
     * @param SortBy Select Input Type
     * @param SortOrder Select Order Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1AlertGet(Type?: Array<string>, Category?: Array<string>, SubCategory?: Array<string>, Component?: Array<string>, IpAddress?: string, OrgId?: Array<number>, Level?: Array<number>, State?: Array<string>, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'body', reportProgress?: boolean): Observable<AlertRetrieveResponseInfo>;
    public evtMgrV1AlertGet(Type?: Array<string>, Category?: Array<string>, SubCategory?: Array<string>, Component?: Array<string>, IpAddress?: string, OrgId?: Array<number>, Level?: Array<number>, State?: Array<string>, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AlertRetrieveResponseInfo>>;
    public evtMgrV1AlertGet(Type?: Array<string>, Category?: Array<string>, SubCategory?: Array<string>, Component?: Array<string>, IpAddress?: string, OrgId?: Array<number>, Level?: Array<number>, State?: Array<string>, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AlertRetrieveResponseInfo>>;
    public evtMgrV1AlertGet(Type?: Array<string>, Category?: Array<string>, SubCategory?: Array<string>, Component?: Array<string>, IpAddress?: string, OrgId?: Array<number>, Level?: Array<number>, State?: Array<string>, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Type) {
            Type.forEach((element) => {
                queryParameters = queryParameters.append('Type', <any>element);
            })
        }
        if (Category) {
            Category.forEach((element) => {
                queryParameters = queryParameters.append('Category', <any>element);
            })
        }
        if (SubCategory) {
            SubCategory.forEach((element) => {
                queryParameters = queryParameters.append('SubCategory', <any>element);
            })
        }
        if (Component) {
            Component.forEach((element) => {
                queryParameters = queryParameters.append('Component', <any>element);
            })
        }
        if (IpAddress !== undefined) {
            queryParameters = queryParameters.set('IpAddress', <any>IpAddress);
        }
        if (OrgId) {
            OrgId.forEach((element) => {
                queryParameters = queryParameters.append('OrgId', <any>element);
            })
        }
        if (Level) {
            Level.forEach((element) => {
                queryParameters = queryParameters.append('Level', <any>element);
            })
        }
        if (State) {
            State.forEach((element) => {
                queryParameters = queryParameters.append('State', <any>element);
            })
        }
        if (StartDateTime !== undefined) {
            queryParameters = queryParameters.set('StartDateTime', <any>StartDateTime);
        }
        if (EndDateTime !== undefined) {
            queryParameters = queryParameters.set('EndDateTime', <any>EndDateTime);
        }
        if (PageNumber !== undefined) {
            queryParameters = queryParameters.set('PageNumber', <any>PageNumber);
        }
        if (PageSize !== undefined) {
            queryParameters = queryParameters.set('PageSize', <any>PageSize);
        }
        if (SortBy !== undefined) {
            queryParameters = queryParameters.set('SortBy', <any>SortBy);
        }
        if (SortOrder !== undefined) {
            queryParameters = queryParameters.set('SortOrder', <any>SortOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<AlertRetrieveResponseInfo>(`${this.basePath}/EvtMgr/V1/Alert`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_DeleteAlert, Delete an Alert
     * Delete an Alert
     * @param Id Enter the Alert Id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1AlertIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public evtMgrV1AlertIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public evtMgrV1AlertIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public evtMgrV1AlertIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1AlertIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/EvtMgr/V1/Alert/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_UpdateAlert, Update the existing record from Alert
     * Update an Alert
     * @param Id Enter the Alert Id that needs to be deleted
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1AlertIdPut(Id: number, Request: AlertUpdateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<AlertUpdateResponseInfo>;
    public evtMgrV1AlertIdPut(Id: number, Request: AlertUpdateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AlertUpdateResponseInfo>>;
    public evtMgrV1AlertIdPut(Id: number, Request: AlertUpdateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AlertUpdateResponseInfo>>;
    public evtMgrV1AlertIdPut(Id: number, Request: AlertUpdateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1AlertIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1AlertIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<AlertUpdateResponseInfo>(`${this.basePath}/EvtMgr/V1/Alert/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrieveAllEvent, Retrieve all event
     * Retrieve all event
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1EventGet(observe?: 'body', reportProgress?: boolean): Observable<EventRetrieveAllResponse>;
    public evtMgrV1EventGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventRetrieveAllResponse>>;
    public evtMgrV1EventGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventRetrieveAllResponse>>;
    public evtMgrV1EventGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<EventRetrieveAllResponse>(`${this.basePath}/EvtMgr/V1/Event`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrieveEventHttpLog, Retrieve EventHttpLog
     * Retrieve EventHttpLog, If TraceId or RequesId is present then StartDate and EndDate is not required
     * @param OrgId Enter the OrgId
     * @param ApiName Enter the ApiName
     * @param SourceApplication Enter the SourceApplication
     * @param Status Enter the Status
     * @param SourceInstance Enter the SourceInstance
     * @param UserId Enter the UserId
     * @param RequestId Enter the RequestId
     * @param TraceId Enter the TraceId
     * @param ExternalRequestId Enter the ExternalRequestId
     * @param AccountNumber Enter the AccountNumber
     * @param ConsumerNumber Enter the ConsumerNumber
     * @param StartDateTime Enter the StartDateTime for CreateDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss format
     * @param EndDateTime Enter the EndDateTime for CreateDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss format, Range between Start and EndateTime be less than 7 days
     * @param PageNumber Enter the page number, where page number starts from 1.
     * @param PageSize Enter records per page. Default page size is 5000.
     * @param SortBy Select Input Type
     * @param SortOrder Select Order Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1EventHttpLogGet(OrgId?: Array<number>, ApiName?: Array<string>, SourceApplication?: Array<string>, Status?: Array<string>, SourceInstance?: Array<string>, UserId?: number, RequestId?: string, TraceId?: string, ExternalRequestId?: string, AccountNumber?: string, ConsumerNumber?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'body', reportProgress?: boolean): Observable<ReteieveResponse>;
    public evtMgrV1EventHttpLogGet(OrgId?: Array<number>, ApiName?: Array<string>, SourceApplication?: Array<string>, Status?: Array<string>, SourceInstance?: Array<string>, UserId?: number, RequestId?: string, TraceId?: string, ExternalRequestId?: string, AccountNumber?: string, ConsumerNumber?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReteieveResponse>>;
    public evtMgrV1EventHttpLogGet(OrgId?: Array<number>, ApiName?: Array<string>, SourceApplication?: Array<string>, Status?: Array<string>, SourceInstance?: Array<string>, UserId?: number, RequestId?: string, TraceId?: string, ExternalRequestId?: string, AccountNumber?: string, ConsumerNumber?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReteieveResponse>>;
    public evtMgrV1EventHttpLogGet(OrgId?: Array<number>, ApiName?: Array<string>, SourceApplication?: Array<string>, Status?: Array<string>, SourceInstance?: Array<string>, UserId?: number, RequestId?: string, TraceId?: string, ExternalRequestId?: string, AccountNumber?: string, ConsumerNumber?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (OrgId) {
            OrgId.forEach((element) => {
                queryParameters = queryParameters.append('OrgId', <any>element);
            })
        }
        if (ApiName) {
            ApiName.forEach((element) => {
                queryParameters = queryParameters.append('ApiName', <any>element);
            })
        }
        if (SourceApplication) {
            SourceApplication.forEach((element) => {
                queryParameters = queryParameters.append('SourceApplication', <any>element);
            })
        }
        if (Status) {
            Status.forEach((element) => {
                queryParameters = queryParameters.append('Status', <any>element);
            })
        }
        if (SourceInstance) {
            SourceInstance.forEach((element) => {
                queryParameters = queryParameters.append('SourceInstance', <any>element);
            })
        }
        if (UserId !== undefined) {
            queryParameters = queryParameters.set('UserId', <any>UserId);
        }
        if (RequestId !== undefined) {
            queryParameters = queryParameters.set('RequestId', <any>RequestId);
        }
        if (TraceId !== undefined) {
            queryParameters = queryParameters.set('TraceId', <any>TraceId);
        }
        if (ExternalRequestId !== undefined) {
            queryParameters = queryParameters.set('ExternalRequestId', <any>ExternalRequestId);
        }
        if (AccountNumber !== undefined) {
            queryParameters = queryParameters.set('AccountNumber', <any>AccountNumber);
        }
        if (ConsumerNumber !== undefined) {
            queryParameters = queryParameters.set('ConsumerNumber', <any>ConsumerNumber);
        }
        if (StartDateTime !== undefined) {
            queryParameters = queryParameters.set('StartDateTime', <any>StartDateTime);
        }
        if (EndDateTime !== undefined) {
            queryParameters = queryParameters.set('EndDateTime', <any>EndDateTime);
        }
        if (PageNumber !== undefined) {
            queryParameters = queryParameters.set('PageNumber', <any>PageNumber);
        }
        if (PageSize !== undefined) {
            queryParameters = queryParameters.set('PageSize', <any>PageSize);
        }
        if (SortBy !== undefined) {
            queryParameters = queryParameters.set('SortBy', <any>SortBy);
        }
        if (SortOrder !== undefined) {
            queryParameters = queryParameters.set('SortOrder', <any>SortOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ReteieveResponse>(`${this.basePath}/EvtMgr/V1/EventHttpLog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_DeleteEvent, Delete the given event
     * Delete the given event
     * @param Id Enter the event Id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1EventIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public evtMgrV1EventIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public evtMgrV1EventIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public evtMgrV1EventIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1EventIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/EvtMgr/V1/Event/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrieveEvent, Retrieve the latest event
     * Retrieve the latest event
     * @param Id Enter the event&#39;s Id that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1EventIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<EventResponseInfo2>;
    public evtMgrV1EventIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventResponseInfo2>>;
    public evtMgrV1EventIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventResponseInfo2>>;
    public evtMgrV1EventIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1EventIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<EventResponseInfo2>(`${this.basePath}/EvtMgr/V1/Event/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_UpdateEvent, Update an event
     * Update an event
     * @param Id Enter the event&#39;s Id that needs to be updated
     * @param Request Enter the id that should be updated for given key with values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1EventIdPut(Id: number, Request: EventUpdateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<EventResponseInfo2>;
    public evtMgrV1EventIdPut(Id: number, Request: EventUpdateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventResponseInfo2>>;
    public evtMgrV1EventIdPut(Id: number, Request: EventUpdateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventResponseInfo2>>;
    public evtMgrV1EventIdPut(Id: number, Request: EventUpdateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1EventIdPut.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1EventIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.put<EventResponseInfo2>(`${this.basePath}/EvtMgr/V1/Event/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrieveEventLog, Retrieve an event in EventLog
     * Retrieve an event in EventLog
     * @param Type Enter the Type
     * @param Category Enter the Category
     * @param SubCategory Enter the SubCategory
     * @param OrgId Enter the OrgId
     * @param Level Enter the Level
     * @param UserId Enter the UserId
     * @param RequestId Enter the RequestId
     * @param StartDateTime Enter the StartDateTime for EventDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss fromat
     * @param EndDateTime Enter the EndDateTime for EventDate in yyyy-MM-dd&#39;T&#39;HH:mm:ss format, Range between Start and EndateTime be less than one day
     * @param PageNumber Enter the page number, where page number starts from 1.
     * @param PageSize Enter the records per page. Default page size is 5000.
     * @param SortBy Select Input Type
     * @param SortOrder Select Order Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1EventLogGet(Type?: Array<string>, Category?: Array<string>, SubCategory?: Array<string>, OrgId?: Array<number>, Level?: Array<number>, UserId?: number, RequestId?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'body', reportProgress?: boolean): Observable<EventLogRetrieveResponseInfo>;
    public evtMgrV1EventLogGet(Type?: Array<string>, Category?: Array<string>, SubCategory?: Array<string>, OrgId?: Array<number>, Level?: Array<number>, UserId?: number, RequestId?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventLogRetrieveResponseInfo>>;
    public evtMgrV1EventLogGet(Type?: Array<string>, Category?: Array<string>, SubCategory?: Array<string>, OrgId?: Array<number>, Level?: Array<number>, UserId?: number, RequestId?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventLogRetrieveResponseInfo>>;
    public evtMgrV1EventLogGet(Type?: Array<string>, Category?: Array<string>, SubCategory?: Array<string>, OrgId?: Array<number>, Level?: Array<number>, UserId?: number, RequestId?: string, StartDateTime?: string, EndDateTime?: string, PageNumber?: string, PageSize?: string, SortBy?: string, SortOrder?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (Type) {
            Type.forEach((element) => {
                queryParameters = queryParameters.append('Type', <any>element);
            })
        }
        if (Category) {
            Category.forEach((element) => {
                queryParameters = queryParameters.append('Category', <any>element);
            })
        }
        if (SubCategory) {
            SubCategory.forEach((element) => {
                queryParameters = queryParameters.append('SubCategory', <any>element);
            })
        }
        if (OrgId) {
            OrgId.forEach((element) => {
                queryParameters = queryParameters.append('OrgId', <any>element);
            })
        }
        if (Level) {
            Level.forEach((element) => {
                queryParameters = queryParameters.append('Level', <any>element);
            })
        }
        if (UserId !== undefined) {
            queryParameters = queryParameters.set('UserId', <any>UserId);
        }
        if (RequestId !== undefined) {
            queryParameters = queryParameters.set('RequestId', <any>RequestId);
        }
        if (StartDateTime !== undefined) {
            queryParameters = queryParameters.set('StartDateTime', <any>StartDateTime);
        }
        if (EndDateTime !== undefined) {
            queryParameters = queryParameters.set('EndDateTime', <any>EndDateTime);
        }
        if (PageNumber !== undefined) {
            queryParameters = queryParameters.set('PageNumber', <any>PageNumber);
        }
        if (PageSize !== undefined) {
            queryParameters = queryParameters.set('PageSize', <any>PageSize);
        }
        if (SortBy !== undefined) {
            queryParameters = queryParameters.set('SortBy', <any>SortBy);
        }
        if (SortOrder !== undefined) {
            queryParameters = queryParameters.set('SortOrder', <any>SortOrder);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<EventLogRetrieveResponseInfo>(`${this.basePath}/EvtMgr/V1/EventLog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_CreateEventLog, Create an event in EventLog
     * Create an event in EventLog
     * @param OrgId Enter the OrgId
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1EventLogPost(OrgId: number, Request: EventLogRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<EventLogRetrieveResponseInfo>;
    public evtMgrV1EventLogPost(OrgId: number, Request: EventLogRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventLogRetrieveResponseInfo>>;
    public evtMgrV1EventLogPost(OrgId: number, Request: EventLogRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventLogRetrieveResponseInfo>>;
    public evtMgrV1EventLogPost(OrgId: number, Request: EventLogRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (OrgId === null || OrgId === undefined) {
            throw new Error('Required parameter OrgId was null or undefined when calling evtMgrV1EventLogPost.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1EventLogPost.');
        }

        let headers = this.defaultHeaders;
        if (OrgId !== undefined && OrgId !== null) {
            headers = headers.set('OrgId', String(OrgId));
        }

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<EventLogRetrieveResponseInfo>(`${this.basePath}/EvtMgr/V1/EventLog`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_CreateEvent, Create an event
     * Create an event
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1EventPost(Request: EventRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<EventResponseInfo>;
    public evtMgrV1EventPost(Request: EventRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<EventResponseInfo>>;
    public evtMgrV1EventPost(Request: EventRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<EventResponseInfo>>;
    public evtMgrV1EventPost(Request: EventRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1EventPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<EventResponseInfo>(`${this.basePath}/EvtMgr/V1/Event`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrieveGatewayTransaction, Retrieve GatewayTransaction
     * Retrieve GatewayTransaction, based in Id
     * @param Id Enter the Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1GatewayTransactionIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<ReteieveResponse2>;
    public evtMgrV1GatewayTransactionIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReteieveResponse2>>;
    public evtMgrV1GatewayTransactionIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReteieveResponse2>>;
    public evtMgrV1GatewayTransactionIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1GatewayTransactionIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<ReteieveResponse2>(`${this.basePath}/EvtMgr/V1/GatewayTransaction/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrieveNotificationLog, Retrieve NotificationLog records
     * Retrieve NotificationLog records
     * @param PolicyDefinitionId Enter the PolicyDefinitionId
     * @param AlertId Enter the AlertId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1NotificationLogGet(PolicyDefinitionId?: number, AlertId?: number, observe?: 'body', reportProgress?: boolean): Observable<NotificationLogRetrieveResponseInfo>;
    public evtMgrV1NotificationLogGet(PolicyDefinitionId?: number, AlertId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationLogRetrieveResponseInfo>>;
    public evtMgrV1NotificationLogGet(PolicyDefinitionId?: number, AlertId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationLogRetrieveResponseInfo>>;
    public evtMgrV1NotificationLogGet(PolicyDefinitionId?: number, AlertId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (PolicyDefinitionId !== undefined) {
            queryParameters = queryParameters.set('PolicyDefinitionId', <any>PolicyDefinitionId);
        }
        if (AlertId !== undefined) {
            queryParameters = queryParameters.set('AlertId', <any>AlertId);
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<NotificationLogRetrieveResponseInfo>(`${this.basePath}/EvtMgr/V1/NotificationLog`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_DeleteNotificationTemplate, Delete the given NotificationTemplate
     * Delete the given NotificationTemplate
     * @param Id Enter the NotificationTemplate Id that needs to be deleted
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1NotificationTemplateIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public evtMgrV1NotificationTemplateIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public evtMgrV1NotificationTemplateIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public evtMgrV1NotificationTemplateIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1NotificationTemplateIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/EvtMgr/V1/NotificationTemplate/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrieveNotificationTemplate, Retrieve the latest NotificationTemplate
     * Retrieve the latest NotificationTemplate
     * @param Id Enter the NotificationTemplate&#39;s Id that needs to be retrieved
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1NotificationTemplateIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<NotificationTemplateResponseInfo2>;
    public evtMgrV1NotificationTemplateIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationTemplateResponseInfo2>>;
    public evtMgrV1NotificationTemplateIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationTemplateResponseInfo2>>;
    public evtMgrV1NotificationTemplateIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1NotificationTemplateIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<NotificationTemplateResponseInfo2>(`${this.basePath}/EvtMgr/V1/NotificationTemplate/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_UpdateNotificationTemplate, Update an NotificationTemplate
     * Update an NotificationTemplate
     * @param Id Enter the NotificationTemplate&#39;s Id that needs to be updated
     * @param Request Enter the id that should be updated for given key with values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1NotificationTemplateIdPatch(Id: number, Request: NotificationTemplateUpdateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<NotificationTemplateResponseInfo2>;
    public evtMgrV1NotificationTemplateIdPatch(Id: number, Request: NotificationTemplateUpdateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationTemplateResponseInfo2>>;
    public evtMgrV1NotificationTemplateIdPatch(Id: number, Request: NotificationTemplateUpdateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationTemplateResponseInfo2>>;
    public evtMgrV1NotificationTemplateIdPatch(Id: number, Request: NotificationTemplateUpdateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1NotificationTemplateIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1NotificationTemplateIdPatch.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<NotificationTemplateResponseInfo2>(`${this.basePath}/EvtMgr/V1/NotificationTemplate/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_CreateNotificationTemplate, Create an NotificationTemplate
     * Create an NotificationTemplate
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1NotificationTemplatePost(Request: NotificationTemplateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<NotificationTemplateResponseInfo>;
    public evtMgrV1NotificationTemplatePost(Request: NotificationTemplateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<NotificationTemplateResponseInfo>>;
    public evtMgrV1NotificationTemplatePost(Request: NotificationTemplateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<NotificationTemplateResponseInfo>>;
    public evtMgrV1NotificationTemplatePost(Request: NotificationTemplateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1NotificationTemplatePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<NotificationTemplateResponseInfo>(`${this.basePath}/EvtMgr/V1/NotificationTemplate`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_DeletePolicyDefinition, Delete PolicyDefinition by Id
     * Delete PolicyDefinition by Id
     * @param Id Enter the PolicyDefinition unique Id that needs to be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1PolicyDefinitionIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public evtMgrV1PolicyDefinitionIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public evtMgrV1PolicyDefinitionIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public evtMgrV1PolicyDefinitionIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1PolicyDefinitionIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/EvtMgr/V1/PolicyDefinition/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrievePolicyDefinition, Get PolicyDefinition by Id
     * Get PolicyDefinition by Id
     * @param Id Enter the PolicyDefinition unique Id that needs to be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1PolicyDefinitionIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<PolicyDefinitionRetreiveResponse>;
    public evtMgrV1PolicyDefinitionIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PolicyDefinitionRetreiveResponse>>;
    public evtMgrV1PolicyDefinitionIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PolicyDefinitionRetreiveResponse>>;
    public evtMgrV1PolicyDefinitionIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1PolicyDefinitionIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<PolicyDefinitionRetreiveResponse>(`${this.basePath}/EvtMgr/V1/PolicyDefinition/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_UpdatePolicyDefinition, Update an PolicyDefinition
     * Update an PolicyDefinition by Id
     * @param Id Enter the PolicyDefinition unique Id that needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1PolicyDefinitionIdPatch(Id: number, Request: PolicyDefinitionUpdateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<PolicyDefinitionRetreiveResponse>;
    public evtMgrV1PolicyDefinitionIdPatch(Id: number, Request: PolicyDefinitionUpdateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PolicyDefinitionRetreiveResponse>>;
    public evtMgrV1PolicyDefinitionIdPatch(Id: number, Request: PolicyDefinitionUpdateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PolicyDefinitionRetreiveResponse>>;
    public evtMgrV1PolicyDefinitionIdPatch(Id: number, Request: PolicyDefinitionUpdateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1PolicyDefinitionIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1PolicyDefinitionIdPatch.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<PolicyDefinitionRetreiveResponse>(`${this.basePath}/EvtMgr/V1/PolicyDefinition/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_CreatePolicyDefinition, Create an PolicyDefinition
     * Create an PolicyDefinition
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1PolicyDefinitionPost(Request: PolicyDefinitionCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<PolicyDefinitionCreateResponseInfo>;
    public evtMgrV1PolicyDefinitionPost(Request: PolicyDefinitionCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PolicyDefinitionCreateResponseInfo>>;
    public evtMgrV1PolicyDefinitionPost(Request: PolicyDefinitionCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PolicyDefinitionCreateResponseInfo>>;
    public evtMgrV1PolicyDefinitionPost(Request: PolicyDefinitionCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1PolicyDefinitionPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PolicyDefinitionCreateResponseInfo>(`${this.basePath}/EvtMgr/V1/PolicyDefinition`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_DeletePolicy, Delete Policy by Id
     * Delete Policy by Id
     * @param Id Enter the Policy unique Id that needs to be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1PolicyIdDelete(Id: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public evtMgrV1PolicyIdDelete(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public evtMgrV1PolicyIdDelete(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public evtMgrV1PolicyIdDelete(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1PolicyIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/EvtMgr/V1/Policy/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_RetrievePolicy, Get Policy by Id
     * Get Policy by Id
     * @param Id Enter the Policy unique Id that needs to be updated
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1PolicyIdGet(Id: number, observe?: 'body', reportProgress?: boolean): Observable<PolicyRetreiveResponse>;
    public evtMgrV1PolicyIdGet(Id: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PolicyRetreiveResponse>>;
    public evtMgrV1PolicyIdGet(Id: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PolicyRetreiveResponse>>;
    public evtMgrV1PolicyIdGet(Id: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1PolicyIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<PolicyRetreiveResponse>(`${this.basePath}/EvtMgr/V1/Policy/${encodeURIComponent(String(Id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_UpdatePolicy, Update an Policy
     * Update an Policy by Id
     * @param Id Enter the Policy unique Id that needs to be updated
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1PolicyIdPatch(Id: number, Request: PolicyUpdateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<PolicyRetreiveResponse>;
    public evtMgrV1PolicyIdPatch(Id: number, Request: PolicyUpdateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PolicyRetreiveResponse>>;
    public evtMgrV1PolicyIdPatch(Id: number, Request: PolicyUpdateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PolicyRetreiveResponse>>;
    public evtMgrV1PolicyIdPatch(Id: number, Request: PolicyUpdateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Id === null || Id === undefined) {
            throw new Error('Required parameter Id was null or undefined when calling evtMgrV1PolicyIdPatch.');
        }
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1PolicyIdPatch.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.patch<PolicyRetreiveResponse>(`${this.basePath}/EvtMgr/V1/Policy/${encodeURIComponent(String(Id))}`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * EvtMgr_CreatePolicy, Create an Policy
     * Create an Policy
     * @param Request Enter the request values
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public evtMgrV1PolicyPost(Request: PolicyCreateRequestInfo, observe?: 'body', reportProgress?: boolean): Observable<PolicyCreateResponseInfo>;
    public evtMgrV1PolicyPost(Request: PolicyCreateRequestInfo, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<PolicyCreateResponseInfo>>;
    public evtMgrV1PolicyPost(Request: PolicyCreateRequestInfo, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<PolicyCreateResponseInfo>>;
    public evtMgrV1PolicyPost(Request: PolicyCreateRequestInfo, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (Request === null || Request === undefined) {
            throw new Error('Required parameter Request was null or undefined when calling evtMgrV1PolicyPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Basic) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set("Accept", httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        let consumes: string[] = [
            'application/json'
        ];
        let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set("Content-Type", httpContentTypeSelected);
        }

        return this.httpClient.post<PolicyCreateResponseInfo>(`${this.basePath}/EvtMgr/V1/Policy`,
            Request,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
